<template>
  <div class="logs-page">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'logs-page',
}
</script>
